export default {
lang: 'tw',
	nav: {
		"nav_lang_zh": '中文（简体）',
		"nav_lang_en": 'English',
		"nav_lang_tw": '中文（繁體）',
		"nav_lang_ja": '日本語',
		"nav_lang_ko": '한국어',
		"nav_lang_de": 'Deutsch',
		"nav_lang_fr": 'Français',
		"nav_lang_th": 'ภาษาไทย',
		"nav_lang_it": 'Italiano',
		"nav_lang_es": 'Español',
		"nav_lang_ru": 'Русский',
		"nav": 'VORMOR AI',
		"nav2": '帳號安全',
		"nav3": '我的雲端硬碟',
		"nav4": '登出登入',
		"nav5": '登入',
		"nav6": '雲空間',
		"nav7": 'ChatGPT大模型',
		"nav8": '智慧型錄音我的雲端硬碟空間系統',
	},
	login: {
	"login1": '密碼登入',
	"login2": '簡訊登入',
	"loginTab3": '郵箱登入',
	"login3": '郵箱',
	"login4": '登入密碼',
	"login5": '手機號碼',
	"login6": '請選擇',
	"login7": '手機驗證碼',
	"login8": '登入',
	"login9": '忘記密碼',
	"login10": '註冊',
	"login11": '登入即表示您同意',
	"login12": '服務協定',
	"login13": '隱私協定',
	"login14": '獲取',
	"login15": '中國',
	"login16": '請輸入帳號',
	"login17": '請輸入密碼',
	"login18": '登入成功!',
	"login19": '請輸入驗證碼!',
	"login20": '發送成功!',
	"login21": '和',

	"login22": '錄音筆雲盤',
	"login23": '我的寫作',
	"login24": '我的對話',
	"login25": '帳號安全',
	"login26": '登出登入',



	"login27": '信箱找回密碼',
	"login28": '郵箱',
	"login29": '信箱驗證碼',
	"login30": '設定登入密碼（6-16位元字元）',
	"login31": '再次輸入登入密碼',
	"login32": '提交',
	"login33": '返回登入',
	"login34": '修改成功!',
	},
	register: {
	"register1": '手機號碼',
	"register2": '請輸入您的手機',
	"register3": '請選擇',
	"register4": '手機驗證碼',
	"register5": '設定密碼',
	"register6": '請輸入驗證碼',
	"register7": '6-16位元字元',
	"register8": '密碼確認',
	"register9": '郵箱',
	"register10": '請輸入信箱',
	"register11": '信箱驗證碼',
	"register12": '請輸入驗證碼',
	"register13": '我已閱讀並同意',
	"register14": '請閱讀並勾選同意協議',
	"register15": '手機號碼格式錯誤 / 手機號碼已註冊',
	"register16": '手機驗證碼錯誤',
	"register17": '請輸入信箱 / 信箱格式錯誤',
	"register18": '信箱格式錯誤',
	"register19": '郵箱驗證碼錯誤',
	"register20": '密碼請設定6-16位元字元',
	"register21": '密碼格式錯誤',
	"register22": '兩次輸入的密碼不一致，請重新輸入',
	"register23": '請輸入密碼',
	"register24": '註冊成功!',
	"register25": '驗證碼錯誤',
	},
	recorder:{
	"recorder1":'錄音筆雲盤',
	"recorder2":'雲端空間容量',
	"recorder3":'檔案',
	"recorder331":'回收站',
	"recorder332":'全部刪除',
	"recorder4":'名稱',
	"recorder5":'音訊時長',
	"recorder6":'檔案大小',
	"recorder7":'創建時間',
	"recorder8":'操作',
	"recorder9":'雲端空間說明',
	"recorder10":'檔案',
	"recorder11":'OCR檔',
	"recorder12":'1.雲空間用途',
	"recorder13":'在智慧辦公本、錄音筆上保存錄音、手寫筆記後，您可以上傳雲盤，即使智慧設備不在身邊，您也可以進入雲空間查看筆記檔案。 ',
	"recorder14":'2.如何上傳雲空間？ ',
	"recorder15":'錄音筆:進入設備【我的檔案】→點擊批量操作→點擊"上傳"，即可將檔案加入雲上傳隊列，上傳至雲空間。 ',
	"recorder16":'智慧辦公本:',
	"recorder17":'管道一:在筆記清單長按，批量選中需要上傳的筆記→點擊"同步"完成上傳； ',
	"recorder171":'管道二:打開單篇筆記詳情頁→點擊【更多-同步】，即可將該筆記上傳至雲空間。 ',
	"recorder18":'未轉寫',
	"recorder19":'查看摘要',
	"recorder20":'講話人',
	"recorder21":'編輯講話人名稱',
	"recorder22":'確定',
	"recorder23":'下載',
	"recorder24":'下載內容:',
	"recorder25":'下載設定:',
	"recorder26":'顯示說話者',
	"recorder27":'取消',
	"recorder28":'連結分享',
	"recorder29":'獲得連結的人都可以訪問，僅支援閱讀，連結7天有效',
	"recorder30":'複製連結',
	"recorder31":'掃一掃，快速檢視',
	"recorder32":'智慧整理',
	"recorder33":'區別說話者',
	"recorder34":'依照講話人角色，智能區分轉寫文字',
	"recorder35":'智慧型口語規則',
	"recorder36":'自動過濾語氣詞、重複詞、停頓詞',
	"recorder37":'非人聲過濾',
	"recorder38":'播放時自動跳過無人聲，噪音的音訊',
	"recorder39":'請選擇',
	"recorder40":'文檔',
	"recorder41":'音訊',
	"recorder42":'文件+音訊',

	"recorder43":'提示',
	"recorder44":'此操作將刪除該檔案, 是否繼續?',
	"recorder441":'此操作將刪除全部檔案, 是否繼續?',
	"recorder45":'確定',
	"recorder46":'取消',
	"recorder47":'刪除成功!',
	"recorder48":'已取消刪除',
	"recorder49":'暫無標記',
	"recorder50":"正在儲存…",
	"recorder51":'回收站',
	},
	personal: {
	"personal1": '帳號設定',
	"personal2": '個人資料',
	"personal3": '頭像',
	"personal4": '上傳檔案',
	"personal5": '支援JPG、JPEG、GIF、PNG 風格，支援 2M 以內的圖片',
	"personal6": '暱稱',
	"personal7": '請輸入暱稱',
	"personal8": '性別',
	"personal9": '先生',
	"personal10": '女士',
	"personal11": '保密',

	"personal12": '生日',
	"personal13": '請選生日',
	"personal14": '職業',
	"personal15": '請選擇職業',
	"personal16": '請輸入職業（非必填）',
	"personal17": '國家',
	"personal18": '請選擇國家',
	"personal19": '保存',
	"personal20": '個人資料',
	"personal21": '帳戶安全',
	"personal22": '只支援2M以內的圖片',
	"personal23": '上傳成功!',
	"personal24": '修改成功!',

	"personal25": '帳戶安全',
	"personal26": '登入密碼',
	"personal27": '修改',
	"personal28": '電子郵件',
	"personal29": '更換',
	"personal30": '帳號註銷',
	"personal32": '確定註銷帳戶嗎？ ',
	"personal33": '登出後，您在帳戶下的全部內容將全部清除，請謹慎操作。 ',
	"personal34": '取消',
	"personal35": '確定',
	"personal36": '身份驗證',
	"personal37": '為確認是您本人操作，請透過信箱驗證碼完成身份驗證',
	"personal38": '信箱',
	"personal39": '驗證碼',
	"personal40": '請輸入驗證碼',
	"personal41": '下一步',
	"personal42": '設定新信箱',
	"personal43": '郵箱',
	"personal44": '請輸入新信箱',
	"personal45": '驗證碼',
	"personal46": '請輸入驗證碼',
	"personal47": '確定',
	"personal48": '設定新登入密碼',
	"personal49": '新登入密碼',
	"personal50": '請輸入新密碼',
	"personal51": '確認新密碼',
	"personal52": '請再輸入新密碼',
	"personal53": '確定',
	"personal54": '獲取',

	"personal55": '信箱格式錯誤',
	"personal56": '更換成功!',
	"personal57": '密碼請設定6-16位元字元',
	"personal58": '兩次輸入的密碼不一致',
	"personal59": '修改成功!',
	"personal60": '登出成功!',
	"share_url": "連結分享",
	 "share_url_7_day": "分享連結有效期為7天。失效前，任何獲得連結的人都可以存取。",
	 "share_audio": "錄音音訊",
	 "share_trans_text": "轉寫內容",
	 "share_summny_text": "總結內容",
	 "share_map": "心智圖",
	 "share_url_pw": "存取加密",
	 "share_random_pw": "密碼隨機產生",
	 "share_url_copy": "複製連結",
	 "share_url_copy_success": "複製連結成功",
	 "share_link_pw": "存取密碼",
	 "share_copy_success": "已將轉寫內容複製到剪切板!",
	 "share_copy_success2": "已將總結內容複製到剪切板!",
	 "share_speaker": "說話者",
	 "share_no_update_speaker": "無法編輯講話人為空",
	 "share_no_trans":"無轉寫文字",
	 "share_no_summny":"無摘要文字",
	 "share_no_map":"無導圖內容",
	 "share_trans_text_1": "轉寫",
	 "share_summny_text_1": "總結",
	 "share_map_1": "導圖",
	 "share_save": "保存成功",
	 "share_no_map":"導圖圖片未生成",
	 "share_update_text2": "編輯總結文本",
	 "showLoading": "載入中...",
	 "handwriting":"手寫內容",
	 "handwritingText":"手寫",
	 "share_1":"本頁手寫內容未識別",
	 "share_2":"編輯手寫辨識",
	 "share_3":"手寫辨識",
	 "share_4":"正在匯出檔案，請勿離開這個頁面",
	 "folder_text":"資料夾",
	  "folder_text_update_name":"重新命名",
	  "folder_text_del":"刪除",
	  "folder_text_all":"全部",
	  "folder_text_type":"檔案類型",
	  "folder_text_audio":"語音筆記",
	  "folder_text_writing":"手寫筆記",
	  "folder_text_file_type":"檔案類型",
	  "folder_text_add":"新建資料夾",
	  "folder_text_input_name":"請輸入名稱",
	  "folder_text_cancel":"取消",
	  "folder_text_summit":"確認",
	  "folder_text_name_not_null":"名稱不能為空",
	  "folder_text_add_success":"建立成功!",
	  "folder_text_del_confirm":"刪除確認",
	  "folder_text_confirm":"確定要刪除選取的資料夾嗎？刪除後資料夾下的筆記將移入回收站。",
	  "folder_text_del_success":"刪除成功!",
	  "folder_text_move":"移到",
	  "folder_text_move_success":"移動成功!",
	  "folder_update_name":"重新命名資料夾",
	  "folder_text_update_success":"修改成功!",
	  "empty_text":"暫無數據",
	  "trans_text_null":"轉寫文字不能為空",
	  "summary_text_null":"摘要總結不能為空",
	  "please_create_folder":"請先創建資料夾"
	}
}